import _ from 'lodash';
import { put, takeLatest, call } from 'redux-saga/effects';
import {
  SEND_OTP,
  SEND_OTP_LOADING,
} from '../actions/customerProfileVerifyAction';
import { sendOtpRequest } from './changeContactSaga';
import { showErrorModal } from '../../../actions/uiActions';
import { returnErrorCode } from '../utils';

function* sendOtpData(payload: any) {
  const {
    featureName,
    callBack,
    email,
    mobile,
    countryCode,
    userId,
    password,
    callBackErrorCodePage,
    defaultErrorCode,
    featureId,
  } = _.get(payload, 'payload', {});
  try {
    yield put({ type: SEND_OTP_LOADING, isSubmitLoading: true });
    const otpRes = yield call(sendOtpRequest, {
      featureName,
      email,
      mobile,
      countryCode,
      userId,
      password,
    });
    const errorCode = _.get(otpRes, 'response.reasonCode', '');
    if (_.isEmpty(errorCode) || errorCode === '200') {
      callBack && callBack();
    } else {
      callBackErrorCodePage &&
        callBackErrorCodePage(
          featureId,
          returnErrorCode(errorCode, defaultErrorCode, featureId),
        );
    }
    yield put({ type: SEND_OTP_LOADING, isSubmitLoading: false });
  } catch (error) {
    yield put({ type: SEND_OTP_LOADING, isSubmitLoading: false });
    // yield put(showErrorModal());
    if (error && error.json) {
      error.json().then((data: any) => {
        const errorCode =
          _.get(data, 'response.reasonCode', '') || _.get(data, 'code', '');
        callBackErrorCodePage &&
          callBackErrorCodePage(
            featureId,
            returnErrorCode(errorCode, defaultErrorCode, featureId),
          );
      });
    } else {
      callBackErrorCodePage &&
        callBackErrorCodePage(
          featureId,
          returnErrorCode(defaultErrorCode, defaultErrorCode, featureId),
        );
    }
  }
}

function* customerProfileVerifySaga() {
  yield takeLatest(SEND_OTP, sendOtpData);
}

export default customerProfileVerifySaga;
